import { useTheme } from "@/components/shell/theme-provider";
import { Button } from "@/components/ui/button";
import { tailwind } from "@/utilities/tailwind-utils";
import { SunIcon, MoonIcon } from "@/utilities/icon-utils";

export function ModeToggle() {
  const { setTheme, theme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className="relative"
    >
      <SunIcon className={tailwind.components.modeToggleSun} />
      <MoonIcon className={tailwind.components.modeToggleMoon} />
      <span className={tailwind.typography.srOnly}>Toggle theme</span>
    </Button>
  );
}
